import { useState, type ReactNode } from 'react'
import {
  RecommendationAccessContext,
  type RecommendationAccess,
} from './recommendation-access-context'
import { MarketingAccessProvider } from './MarketingAccess'
export function RecommendationAccessProvider({
  children,
}: {
  children: ReactNode
}) {
  const [access, setAccess] = useState<RecommendationAccess | null>(null)
  return (
    <MarketingAccessProvider>
      <RecommendationAccessContext value={{ access, setAccess }}>
        {children}
      </RecommendationAccessContext>
    </MarketingAccessProvider>
  )
}
